export enum SocialSickLeaveDurationType {
  DAYS = 'Days',
  HOURS = 'Hours',
}
